module.exports = __webpack_public_path__ + "static/media/store.cb64620f.jpg";